import { openConfirmDialog } from "@/src/components/dialogs";

export function openReferenceGuidelinesDialog() {
  return openConfirmDialog({
    id: "referenceGuidelinesDialog",
    title: "Veuillez changer le nom de l'élément",
    content: (
      <div className="c1 gap10">
        <div>
          - L élément ne doit pas contenir de charactères spéciaux (Ex: +, %, $)
        </div>
        <div>
          - Ne doit pas contenir plusieurs éléménets (Ex: Fièvre ET
          vomissements).
        </div>
        <div>
          - Pour ajouter plusieurs éléments, veuillez les ajouter séparément
          (Ex: Fièvre seule, puis Vomissements seuls)
        </div>
        <div>
          - Ne doit pas contenir de durée (Ex: depuis), les durées sont ajoutée
          comme remarques
        </div>
      </div>
    ),
  });
}
